module.exports = __webpack_public_path__ + "static/media/ic_web_clipboard-alt.dd5aaef8.svg";